import * as React from 'react';
import { ReactComponent as CallCenterIconSVG } from '../../assets/icons/mevo/ic_call_center.svg';
import IconPattern, { IconProps } from './_IconPattern';

const CallCenterIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={CallCenterIconSVG} variantPlaces={3} {...props} />;
};

export default CallCenterIcon;
